import React from 'react'
import clsx from 'clsx'
import { X } from 'lucide-react'
import { formatDistanceToNow } from 'date-fns'
import type { AIAlert } from '../../types/event.types'
import styles from './AlertItem.module.css'

export interface AlertItemProps {
  alert: AIAlert
  onDismiss: () => void
  className?: string
}

const SEVERITY_CONFIG = {
  info: { icon: '💡', className: styles.info },
  warning: { icon: '⚠️', className: styles.warning },
  critical: { icon: '🚨', className: styles.critical },
}

export function AlertItem({ alert, onDismiss, className }: AlertItemProps) {
  const cfg = SEVERITY_CONFIG[alert.severity] ?? SEVERITY_CONFIG.info

  const receivedDate = alert.received_at instanceof Date
    ? alert.received_at
    : new Date(alert.received_at)

  const timeAgo = !isNaN(receivedDate.getTime())
    ? formatDistanceToNow(receivedDate, { addSuffix: true })
    : 'just now'

  return (
    <div className={clsx(cfg.className, className)} role="alert" data-severity={alert.severity}>
      <span className={styles.icon}>{cfg.icon}</span>
      <div className={styles.body}>
        <p className={styles.message}>{alert.message}</p>
        <span className={styles.meta}>
          {alert.source === 'ai' ? '🤖 AI' : '📏 Rule'} · {timeAgo}
        </span>
        {alert.action_url && (
          <a href={alert.action_url} className={styles.action}>
            Take action →
          </a>
        )}
      </div>
      <button
        type="button"
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        <X size={12} />
      </button>
    </div>
  )
}
